$(document).ready(function(){  
  let case_index = null;

  $(document).on('gbbMix-bundle-initialized gbbMix-next-data-loaded', function(){   
    //console.log('gbb mix init1', $('.gbbMixCascadeProductWrapper').length); 
    $('.gbbMixCascadeProductWrapper').each(function(index){
      var selected_variant_id = $(this).data('current-selected-variant-id');
      var variant_meta = window.themeVariables.variantsMeta[selected_variant_id];
      //console.log($(this).data('product-quantity'));
      if(variant_meta.is_container == 'true' && $(this).data('product-quantity') > 0){
        //console.log({index});
        case_index = index;
        return;
      }
    });

    //Change image on variant click
    $('.gbbMixCascadeProductWrapper').on('mousedown', function(){
      $('.gbbMixCascadeProductWrapper').removeClass('active');
      $(this).addClass('active');
      var selected_variant_id = $(this).data('current-selected-variant-id');
      var variant_meta = window.themeVariables.variantsMeta[selected_variant_id];
      //console.log({selected_variant_id}, variant_meta);
      var variant_images = variant_meta.variant_images != '' ? variant_meta.variant_images.split(',') : null;
      //console.log({variant_images});

      if(variant_meta.single_step_bundle == 'true'){
        if(variant_meta.featured_image){
          $('.bundle-item-image img').attr('src', variant_meta.featured_image);
          $('scroll-shadow.product-gallery__thumbnail-list-wrapper, .product-gallery__ar-wrapper').addClass('hide');
          $('.bundle-item-image').removeClass('hide');
        }
        var variant_title = $(this).find('.gbbMixCascadeCurrentVariantTitle').text();
        $('.product-variant-info-main').remove();
        $('.gbbMixCascadeBodyContent').after(
          `<div class="product-variant-info-main" style="border-color: ${variant_meta.variant_color};"><div class="info-wrap"><h4>${variant_title}</h4><p>${variant_meta.short_description}</p></div></div>`
        );
        $('.product-variant-info')
          .html(`<div class="info-wrap"><h4>${variant_title}</h4><p>${variant_meta.short_description}</p></div>`)
          .addClass('active')
          .css('border-color', variant_meta.variant_color);
        $(window).scrollTop($(window).scrollTop() + 1);
      } else {
        if(variant_meta.is_container == 'true'){
          if(variant_meta.featured_image){
            $('.bundle-item-image img').attr('src', variant_meta.featured_image);
            $('scroll-shadow.product-gallery__thumbnail-list-wrapper, .product-gallery__ar-wrapper').addClass('hide');
            $('.bundle-item-image').removeClass('hide');
          }
          case_index = parseInt($('.gbbMixCascadeProductWrapper').index(this));
        } else {
          if(variant_images){
            $('.bundle-item-image img').attr('src', variant_images[case_index]);
            $('scroll-shadow.product-gallery__thumbnail-list-wrapper, .product-gallery__ar-wrapper').addClass('hide');
            $('.bundle-item-image').removeClass('hide');
          }
          var variant_title = $(this).find('.gbbMixCascadeCurrentVariantTitle').text();
          $('.product-variant-info-main').remove();
          $('.gbbMixCascadeBodyContent').after(
            `<div class="product-variant-info-main" style="border-color: ${variant_meta.variant_color};"><div class="info-wrap"><h4>${variant_title}</h4><p>${variant_meta.short_description}</p></div></div>`
          );
          $('.product-variant-info')
            .html(`<div class="info-wrap"><h4>${variant_title}</h4><p>${variant_meta.short_description}</p></div>`)
            .addClass('active')
            .css('border-color', variant_meta.variant_color);
          $(window).scrollTop($(window).scrollTop() + 1);
        }
      }

    });

    $('.gbbMixCascadeCategoryTab').on('click', function(){
      $('.product-variant-info-main').remove();
      $('.product-variant-info').html('').removeClass('active');
    });   
    
    $('.gbbMixCascadeCartDrawerBtnText').text('View Items');
    // $('.product-info__price sale-price').text($('.gbbMixCascadeAddToCartBtnPrice').text());
    // $('sale-price').show();
  });

  $(document).on('gbbMix-cartData-update', function(){
    $('.gbbMixCascadeCartDrawerBtnText').text('View Items');
    // $('.product-info__price sale-price').text($('.gbbMixCascadeAddToCartBtnPrice').text());
    // $('sale-price').show();
  });

  // $(document).on('gbbMix-subscription-purchase-option-change', function(){
  //   $('.product-info__price sale-price').text($('.gbbMixCascadeAddToCartBtnPrice').text());
  //   $('sale-price').show();
  // });

  let ticking = false;

  $(window).on('scroll', function () {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(function () {

      if ($(window).width() > 768) {
        ticking = false;
        return; // mobile only
      }

      const $info = $('.product-variant-info');
      const $infoMain = $('.product-variant-info-main');

      if (!$info.length || !$infoMain.length) {
        ticking = false;
        return;
      }

      const scrollTop = $(window).scrollTop();

      const infoTopOffset = $info.offset().top;
      const mainTopOffset = $infoMain.offset().top;
      const mainHeight = $infoMain.outerHeight();
      const mainBottomOffset = mainTopOffset + mainHeight;
      //console.log({scrollTop, infoTopOffset, mainTopOffset, mainHeight, mainBottomOffset});      

      //Convert offsets to viewport
      const infoTopInView = infoTopOffset - scrollTop;
      const mainTopInView = mainTopOffset - scrollTop;
      const mainBottomInView = mainBottomOffset - scrollTop;

      // Apply 10px early trigger for bottom
      const mainBottomInViewMinus10 = mainBottomInView - 40;

      // Console logs
      // console.log({
      //   infoTopInView,
      //   mainTopInView,
      //   mainBottomInView,
      //   mainBottomInViewMinus10,
      //   mainHeight
      // });
      // console.log('diff:', (infoTopInView - mainTopInView), (infoTopInView - mainBottomInViewMinus10));

      if(infoTopInView < mainTopInView){
        $info.addClass('active');
       $infoMain.addClass('opacity0');
      } else {
        $info.removeClass('active');
        $infoMain.removeClass('opacity0');
      }

      // // Remove active when info meets TOP of main
      // if ((infoTopInView - mainTopInView) <= 1) {
      //   console.log("Removing active (top meet)");
      //   $info.removeClass('active');
      // }

      // // Add active when info meets BOTTOM-10px of main
      // if ((infoTopInView - mainBottomInViewMinus10) <= 1) {
      //   console.log("Adding active (10px before bottom meet)");
      //   $info.addClass('active');
      // }

      ticking = false;
    });
  });
});